import React, { useState, useCallback, useEffect } from 'react';
import { RadioButton } from '@superops/ui-design-system';

function RadioField(props) {
  const { label } = props.attribute;

  const { options } = props;

  const [value, setValue] = useState(props.value || '');

  useEffect(() => {
    setValue(props.value || '');
  }, [props.value]);

  const handleChange = useCallback((newValue) => {
    setValue(newValue);
    props.handleChange(newValue);
  }, []);

  return (
    <div className="w100 pl8 flex col overflow-y-auto">
      <div>{label}</div>
      {options.map((item) => {
        return (
          <RadioButton
            label={item}
            name={`${props.attribute.columnName}__${item}`}
            id={`${props.attribute.columnName}__${item}`}
            checked={value === item}
            onChange={(checked, newVal) => handleChange(newVal.split('__')[1])}
          />
        );
      })}
    </div>
  );
}

export default RadioField;
